import React, { Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { styled } from 'styled-components';
import SvgHistory from '../../../../../play-core/icons/History';
import SvgVideo from '../../../../../play-core/icons/Video';
import { Colors } from '../../../../../play-core/styles/Colors';
import { Viewports } from '../../../../../play-core/styles/Viewports';
import { useAnalyticsDispatch } from '../../../analytics/AnalyticsContext';
import { useViewport } from '../../../providers/ViewportProvider/ViewportContext';
import { PlaySecondaryLink } from '../../ClickableComponents/PlayLink';
import { IconWrapper } from '../../IconWrapper/IconWrapper';
import { isLive, useDetailOrRedirectPath, useLivestreamOrRedirectPath } from '../tv-guide-types';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export const PlayButtons = ({
  program,
  channel,
  analyticsPageId,
  onClose
}) => {
  const analytics = useAnalyticsDispatch();
  const {
    t
  } = useTranslation();
  const {
    isSmall
  } = useViewport();
  const nowPlaying = isLive(program);
  const detailPath = useDetailOrRedirectPath(program, channel);
  const livePath = useLivestreamOrRedirectPath(program, channel);
  const detailPathText = nowPlaying ? t('global.watchFromBeginning') : t('global.play');
  return /*#__PURE__*/_jsx(Fragment, {
    children: (nowPlaying || program.mediaUrn) && /*#__PURE__*/_jsxs(Layout, {
      children: [nowPlaying && livePath && /*#__PURE__*/_jsx(PlaySecondaryLink, {
        to: livePath,
        expand: isSmall,
        text: t('global.play'),
        ariaLabel: `${t('global.play')} - ${program.title}`,
        icon: /*#__PURE__*/_jsx(IconWrapper, {
          icon: /*#__PURE__*/_jsx(SvgVideo, {
            isHovering: true
          }),
          color: Colors.WHITE
        }),
        onClick: () => {
          onClose();
          window.scrollTo(0, 0);
          analytics({
            type: 'click-event',
            name: 'TvGuidePlayLivestream',
            value1: analyticsPageId,
            value2: channel.title,
            value4: program.mediaUrn
          });
        }
      }), detailPath && /*#__PURE__*/_jsx(PlaySecondaryLink, {
        to: detailPath,
        expand: isSmall,
        text: detailPathText,
        ariaLabel: `${detailPathText} - ${program.title}`,
        icon: /*#__PURE__*/_jsx(IconWrapper, {
          icon: nowPlaying ? /*#__PURE__*/_jsx(SvgHistory, {}) : /*#__PURE__*/_jsx(SvgVideo, {
            isHovering: true
          }),
          color: Colors.WHITE
        }),
        onClick: () => {
          onClose();
          analytics({
            type: 'click-event',
            name: 'TvGuidePlayMedia',
            value1: analyticsPageId,
            value2: program.mediaUrn,
            value4: nowPlaying ? channel.title : undefined
          });
        }
      })]
    })
  });
};
const Layout = styled.div.withConfig({
  displayName: "PlayButtons__Layout",
  componentId: "sc-zns98p-0"
})(["margin:16px 0;align-self:flex-start;display:grid;grid-auto-flow:column;grid-gap:16px;", "{width:100%;grid-auto-flow:row;}"], Viewports.for('small'));